<template>
  <div style="height: 60px;">
    <el-header class="body-header" style="position: fixed;top:0px;z-index:200">
      <div class="header-first">
        <img src="../../../assets/images/hansen-logo.png" style="height: 30px;"></img>
        <div class="gap_line"></div>
        <div class="first_right">
          <div>汉森数智化协同平台</div>
          <div>COLLABORATION PLATFORM</div>
        </div>
      </div>
      <div class="header-tab">
        <div class="back-logo">
          <el-button :class="{'grey-back':activatedName === 'main'?true:false,}" style="position: relative;right: 18px;bottom: 12px;border:none !important;background-color: transparent !important;" type="text" @click="goUrl('main')">首页</el-button>
        </div>
        <div class="back-logo">
          <el-button :class="{'grey-back':activatedName === 'noticeLists'?true:false,}" style="position: relative;right: 32px;bottom: 12px;border:none !important;background-color: transparent !important;" type="text" @click="goUrl('noticeLists')">资讯中心</el-button>
        </div>
        <div class="back-logo">
          <el-button :class="{'grey-back':activatedName === 'systemList'?true:false,}" style="position: relative;right: 32px;bottom: 12px;border:none !important;background-color: transparent !important;" type="text" @click="goUrl('systemList')">服务中心</el-button>
        </div>
      </div>
      <div class="header-input">
        <el-input v-model="personName" @keyup.enter.native="goPerson" placeholder="输入姓名/工号/手机号搜索"
          suffix-icon="el-icon-search" />
        <el-tooltip effect="dark" content="打开默认浏览器" placement="top-start">
          <i class="el-icon-help cursor_point" @click="openPortal" v-if="showIcon"></i>
        </el-tooltip>
         <el-badge :value="emailCount" class="item">
        <i class="el-icon-message cursor_point" @click="goEmail"></i>
        </el-badge>
        <el-badge :value="messageCount" class="item">
          <i class="el-icon-bell cursor_point" @click="goMessage"></i>
        </el-badge>
        <el-dropdown @command="handleCommand">
          <span class="el-dropdown-link">
            {{ user.userName }}<i class="el-icon-arrow-down el-icon--right"></i>
          </span>
          <el-dropdown-menu slot="dropdown">
            <!-- <el-dropdown-item command="个人主页">个人主页</el-dropdown-item>
              <el-dropdown-item command="个人设置">个人设置</el-dropdown-item>
              <el-dropdown-item command="授权管理">授权管理</el-dropdown-item>
              <el-dropdown-item command="账号管理">账号管理</el-dropdown-item>
              <el-dropdown-item command="应用配置">应用配置</el-dropdown-item> -->
            <el-dropdown-item command="changePassword">修改密码</el-dropdown-item>
            <el-dropdown-item divided command="layout">退出登录</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
      </div>
      <div class="header-end">
        <img src="../../../assets/images/header-right.png" style="height: 30px;"></img>
      </div>
    </el-header>
    <el-dialog :title="title" :visible.sync="dialogFormVisible" width="30%">
      <el-container>
        <el-main class="table-main">
          <el-form :model="form" label-width="80px">
            <el-form-item label="输入旧密码 " prop="oldPassword">
              <el-input v-model="form.oldPassword" show-password></el-input>
            </el-form-item>
            <el-form-item label="输入新密码" prop="newPassword">
              <el-input v-model="form.newPassword" show-password></el-input>
            </el-form-item>
            <el-form-item label="确认新密码 " prop="reNewPassword">
              <el-input v-model="form.reNewPassword" show-password></el-input>
            </el-form-item>
          </el-form>
        </el-main>
        <el-footer class="table-footer">
          <el-button @click="dialogFormVisible = false" class="btnPass">取 消</el-button>
          <el-button type="primary" @click="updateUser(form)" class="btnPass left">确 定</el-button>
        </el-footer>
      </el-container>
    </el-dialog>
  </div>
</template>

<script>
import Cookies from "js-cookie";
export default {
  data() {
    return {
      user: {},
      personName: '',
      form: {},
      title: "修改密码",
      dialogFormVisible: false,
      activatedName: '',
      messageCount: 0,
      emailCount: 0,
      showIcon: true
    }
  },
  methods: {
    isInWorkWechat() {
      const ua = window.navigator.userAgent.toLowerCase();
      console.log('ua判断企微',ua,'-——————————————————————————————————————————————————————————————————————-')
      this.showIcon = ua.includes("micromessenger") && ua.includes("wxwork");
    },
    isIOSSafari() {
      const ua = navigator.userAgent || '';
      const isiOS = /iP(hone|od|ad)/i.test(ua);
      // 只对 iOS Safari 生效：排除 Chrome/Firefox 等内核浏览器
      const isSafari = /Safari/i.test(ua) && !/CriOS/i.test(ua) && !/FxiOS/i.test(ua);
      return isiOS && isSafari;
    },
    openPortal(){
      let localUrl = ''
      localUrl = window.location.href
      console.log('getSystemInfo', localUrl)
      this.$axios.post(
        this.global.BASE_URL + '/msi/qywx/info/conf/jsapi/sign',
        {
          data: {
            wechatCode: 'oa',
            url: this.global.BASE_URL + '/',
          },
          asp: JSON.parse(localStorage.getItem('user')).asp,
        }
      ).then(res => {
        if (res.data.code === '0000') {
          console.log(res.data.data,'res.data.data')
            ww.register({
              corpId: res.data.data.appId,
            agentId:res.data.data.agentId,
            getConfigSignature:()=>{
              return {
                timestamp: res.data.data.timestamp, 
                nonceStr: res.data.data.nonceStr, // 必填，生成签名的随机串
                signature: res.data.data.signature
              } 
            },
            getAgentConfigSignature:()=>{
              return {
                timestamp: res.data.data.timestamp, 
                nonceStr: res.data.data.nonceStr, // 必填，生成签名的随机串
                signature: res.data.data.signature2
              } 
            }
            , // 必填，签名
              jsApiList: [
                'openDefaultBrowser',	
              ],
            debug: true
            })
          const doOpen = () => {
            ww.openDefaultBrowser({
              url: `${this.global.BASE_URL}/#/?token=${Cookies.get(`token_${window.location.port}`)}`,
              success: function (res) {
                console.log('打开默认浏览器成功');
              }
            })
          }

          // iOS Safari 会拦截“非用户触发”的自动跳转；仅 iOS Safari 弹窗确认
          if (this.isIOSSafari()) {
            this.$confirm('iOS 可能会拦截自动跳转，点击“确认”后将打开默认浏览器继续。', '提示', {
              confirmButtonText: '确认',
              cancelButtonText: '取消',
              type: 'warning',
              center: true
            })
              .then(() => {
                doOpen()
              })
              .catch(() => {})
          } else {
            doOpen()
          }
          console.log('------------------------------------')
        }
      })	
    },
    goMessage(){
      // 通知消息页面刷新列表
      this.$bus && this.$bus.$emit('refreshMessageList');
      this.$router.push({name:"message"})
    },
    goEmail(){
      
      let url = `${this.global.BASE_URL}/msi/oa/external/email/emailSso?sys=1`;
      this.$axios.get(url, {}).then(res => {
        if(res.data.code === '0000'){
          console.log(res.data.data,'res.data.data')
          window.open(res.data.data,'_blank');
        }
      });
    },
    goUrl(name) {
      this.activatedName = name
      console.log(name,'name')
      this.$router.push({ name })
    },

    getEmailCount(){
      this.$axios({
            method: "get",
            url: this.global.BASE_URL_2971 + "/msi/oa/external/email/getNewMailCount",
            data: {
            },
            })
              .then((res) => {
                if(res.data.code === '0000'){
                  if(res.data.count > 99){
                  this.emailCount = '99+'
                }else{
                  this.emailCount = res.data.data
                }
                console.log(this.emailCount,res.data.data)
              }
            })
            .catch((error) => {
              console.log(error); // 请求失败返回的数据
            });
    },

    getMessageCount(){
      this.$axios({
            method: "post",
            url: this.global.BASE_URL_2971 + "/msi/oa/message/findMessages",
            data: {
              data:{
                status: 20
              }
            },
          })
            .then((res) => {
              if(res.data.code === '0000'){
                if(res.data.count > 99){
                  this.messageCount = '99+'
                }else{
                  this.messageCount = res.data.count
                }
                console.log(this.messageCount,res.data.data)
              }
            })
            .catch((error) => {
              console.log(error); // 请求失败返回的数据
            });
    },
    handleCommand(command) {
      console.log('handleCommand', command)
      if (command === "changePassword") {
        this.form.title = "修改密码";
        this.form = {};
        this.dialogFormVisible = true;
      }else if(command === "layout"){
        // 退出方法
        if(Cookies.get(`token_${window.location.port}`)){
          new Promise((resolve, reject) => {
            // this.tutorOffLine()
            resolve();
          }).then(() => {
            this.$axios({
              method: "post",
              url: this.global.BASE_DMZ + "/staff/logout",
              headers: {
                certificate: Cookies.get(`token_${window.location.port}`),
              },
              //   beforeSend: function(request) {
              // 	  debugger
              // 	 request.setRequestHeader("token", Cookies.get(`token_${window.location.port}`));
              // },
              data: this.qs.stringify({
                certificate: Cookies.get(`token_${window.location.port}`),
              }),
            })
              .then((response) => {
                Cookies.remove("token");
                // location.reload();
                this.$router.push({path:'/login'})
              })
              .catch((error) => {
                console.log(error); // 请求失败返回的数据
              });
          });
        }else{
          this.$router.push({path:'/login'})
        }
      }
    },
    updateUser(form) {
      if (form.newPassword != form.reNewPassword) {
        this.$message({
          showClose: true,
          message: "两次输入密码不一致",
          type: "error",
        });
        return false;
      }
      let userId = JSON.parse(localStorage.getItem("user")).userId;
      let userType = JSON.parse(localStorage.getItem("user")).userType;
      let param = {
        data: {
          userId: userId,
          type: userType,
          oldPassword: form.oldPassword,
          newPassword: form.newPassword,
        },
      };
      this.$axios({
        method: "post",
        url: this.global.BASE_INFO + "/user/updateUserPasswd",
        data: JSON.stringify(param),
        headers: {
          certificate: Cookies.get(`token_${window.location.port}`),
          "Content-Type": "application/json",
        },
      })
        .then((response) => {
          if (response.data.status === "Y") {
            this.$message({
              showClose: true,
              message: response.data.message,
              type: "success",
            });
            // Cookies.remove("token");
            // location.reload();
            this.dialogFormVisible = false;
          }
        })
        .catch((error) => {
          console.log(error); // 请求失败返回的数据
        });
    },
    goPerson() {
      console.log(this.$route,'goPerson')
      if(this.$route.name === 'searchPerson'){
        this.$bus && this.$bus.$emit('searchPersonList',this.personName);
      }else{
        this.$router.push({ name: 'searchPerson', params: { searchName: this.personName } })
      }
      this.personName = ''
    },
  },
  created() {
    this.getMessageCount()
    this.getEmailCount()
    this.isInWorkWechat()
    this.$bus && this.$bus.$on('refreshMessageCount', this.getMessageCount);
    setTimeout(()=>{
      this.user = JSON.parse(localStorage.getItem('user'))
      this.activatedName = this.$route.name
    },200)
  },
  beforeDestroy() {
    this.$bus && this.$bus.$off('refreshMessageCount', this.getMessageCount);
  },
  mounted(){
    console.log('headerMounted')
  },
}
</script>
<style lang="less" scoped>
.gap_line{
  background: linear-gradient(180deg, transparent, #bfc3c7, transparent);
  width: 1px;
  height: 30px;
  margin: auto 14px;
}
.el-popper {
  margin-top: 0px !important;
}
.body-header {
  background-color: #ffffff;
  width: 100%;
  min-width: 1200px;
  height: 60px;
  box-shadow: 0px 1px 5px rgba(0, 0, 0, 0.05);
  display: flex;
  justify-content: space-between;
  color: #fff;
  padding: 0 20px;
  margin-bottom: 0;

  .header-first {
    font-size: 18px;
    font-weight: 600;
    display: flex;
    margin: 15px 0;

    .first_right {
      color: #717171;
      // margin-left: 20px;
      font-size: 7px;
      // border-left: 1px solid #7171717a;
      // padding-left: 20px;
      font-weight: 500;

      div:first-child {
        font-size: 16px;
      }
    }
  }

  .header-tab {
    display: flex;

    /deep/ .el-button--text {
      color: #474c51;
      font-size: 16px;
    }

    /deep/ .grey-back {
      background: linear-gradient(to right,#bb0009, #e52030);
      /* 将背景裁剪为文字形状 */
      -webkit-background-clip: text;
      background-clip: text;
      /* 设置文字颜色为透明，以显示背景渐变 */
      color: transparent;
      /* 兼容性设置 */
      -webkit-text-fill-color: transparent;
      display: inline-block; /* 确保渐变效果正确应用 */
    }

    .back-logo {
      box-sizing: border-box;
      margin-left: 80px;
      margin-top: 15px;
      width: 30px;
      height: 30px;
      position: relative;

      &::before {
        content: '';
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background: url(../../../assets/images/closeLogo.png) no-repeat;
        background-size: 100% 100%;
        opacity: 0.5;
        z-index: 1;
      }

      .el-button {
        position: relative;
        z-index: 2;
      }

      .el-button:hover {
        color:#bb0009;
      }
    }
    .back-logo:hover {
      &::before {
        background: url(../../../assets/images/openLogo.png) no-repeat;
        background-size: 100% 100%;
      }
    }
  }

  .header-input {
    display: flex;
    justify-content: space-between;

    /deep/ .el-badge__content.is-fixed {
      top: 18px !important;
    }

    /deep/ .el-input__inner {
      background-color: transparent !important;
      border: 1px solid #e6e8eb;
      color: #474c51;
      height: 30px;
      line-height: 30px;
      font-size: 12px;
    }

    i {
      color: #474c51;
      font-size: 18px;
      height: 60px;
      line-height: 60px;
      margin-left: 20px;
    }

    .el-dropdown-link {
      color: #474c51;
      margin: 0 30px 0 20px;
      display: flex;
      width: 100%;

      i {
        font-size: 18px;
        margin-left: 10px;
      }
    }
  }

  .header-input i:hover {
    cursor: pointer;
    color:#bb0009 !important;
  }

  .el-dropdown-link:hover {
    cursor: pointer;
    color:#bb0009 !important;
  }

  .header-tab,.header-input {
    height: 60px;
    line-height: 60px;
  }

  .header-end {
    display: flex;
    margin: 15px 0;
  }

  /deep/ .el-input__suffix {
    color: #474c51 !important;
  }
}

</style>


// WEBPACK FOOTER //
// src/views/main/components/MainHeader.vue